import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';
import axios from "axios";
import QuestionContents from './UI/QuestionContents';
import { useAuth } from '../../../../../context/AuthContext';
import { useParams } from "react-router-dom";
import './matchcss.css';

const TrueFalse = (props) => {
    const { t } = useTranslation();
    const [msg, setMsg] = useState([]);
    const [question, setQuestion] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [questionTitle, setQuestionTitle] = useState([]);
    const [questionText, setQuestionText] = useState([]);
    const [attempt, setAttempt] = useState(0);
    const { user } = useAuth();
    const params = useParams();
    const [subjectName, setSubjectName] = useState("");
    const ATTEMPT_KEY = `choice_attempt_${props.questionNumber}`;

    const getSubject = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/GetSubject";
            await axios({
                method: 'GET',
                url: url,
                headers: headerss
            }).then(res => {
                if (res.data['success']) {
                    setSubjectName(res.data['data']['subjects'][params['subjectid'] - 1]['subjectName'] + " - " + res.data['data']['subjects'][params['subjectid'] - 1]['subjectDesc'])
                }
            });
        } catch (err) {
            console.log();
        }
    };
    const Request = async (userAnswer) => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/Answer";
            await axios({
                method: 'GET',
                url: url,
                params: {
                    questionId: props.questionNumber,
                    answer: userAnswer.toString()
                },
                headers: headerss
            }).then(res => {
                localStorage.removeItem(ATTEMPT_KEY);

                if (res.data['success']) {
                    let audio = new Audio("https://api.heryerdeingilizce.com/sound/d6350096-7457-46bc-bcaa-313a33970558.mp4");
                    audio.play();
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        confirmButtonText: `Tamam`,
                        timer: 3000,
                    }).then(() => {
                        let newurl = Number(params['id']) + 1;
                        window.location.href = "/user/course/question/" + params['subjectid'] + "/" + newurl;
                    });
                }
                else {
                    if (res.data['alertType'] === "question") {
                        let audio = new Audio("https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4");
                        audio.play();
                        Swal.fire({
                            title: "Hatalı cevap",
                            text: "Doğru Cevap: " + res.data['message'],
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                    else {
                        let errorMsg = res['data']['message'];
                        let audio = new Audio("https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4");
                        audio.play();
                        Swal.fire({
                            title: "Hata",
                            text: errorMsg,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                }
            });
        } catch (err) {
            setMsg(err.message);
        }
    };

    const answerTrueFalseHandle = async (e) => {
        e.preventDefault();
        let userAnswer = "";
        for (let i = 0; i < props.truefalseanswercount; i++) {
            const trueEl = document.getElementById(i + ".true");
            const falseEl = document.getElementById(i + ".false");
            if (trueEl.checked) {
                userAnswer += "true";
            } else if (falseEl.checked) {
                userAnswer += "false";
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Lütfen tüm seçenekleri cevaplayın.',
                    confirmButtonText: 'Tamam'
                });
                return;
            }
            if (i < props.truefalseanswercount - 1) userAnswer += ",";
        }
        const attempt = parseInt(localStorage.getItem(ATTEMPT_KEY));
        const correctAnswer = props.data.answer;

        //1. DENEME
        if (attempt === 0) {
            if (userAnswer === correctAnswer) {
                Request(userAnswer);
            } else {
                localStorage.setItem(ATTEMPT_KEY, "1");

                new Audio(
                    "https://api.heryerdeingilizce.com/sound/f174007c-0602-4455-8463-ae6a3285f02c.mp4"
                ).play();

                Swal.fire({
                    title: "Tekrar Deneyiniz!",
                    text: props.data.notfyText,
                    icon: "warning",
                }).then(() => window.location.reload());
            }
            return;
        }

        // 2. DENEME → DİREKT BACKEND
        Request(userAnswer);


    };
    useEffect(() => {
        if (localStorage.getItem(ATTEMPT_KEY) === null) {
            localStorage.setItem(ATTEMPT_KEY, "0");
        }

        return () => {
            localStorage.removeItem(ATTEMPT_KEY);
        };
    }, [ATTEMPT_KEY]);
    useEffect(() => {

        getSubject();
        setQuestion(JSON.parse(props.data.contentStr));
        setAnswers(JSON.parse(props.data.detail));
        let que = JSON.parse(props.data.contentStr);
        let questionTitlee = que['text'].split('__')[0];
        let questionTextt = que['text'].split('__')[1];
        setQuestionTitle(questionTitlee);
        setQuestionText(questionTextt);
    }, []);

    return (
        <div>
            <span style={{ color: "black" }}> <b><i>{subjectName}</i></b></span>
            <br />
            <b>True False Sorusu</b>
            <br />
            <div style={{ textAlign: "center" }}>
                <QuestionContents question={question} />
                <br /><br />
                <b style={{ fontSize: "18px", fontFamily: 'calibri', color: "SteelBlue" }}>
                    {questionTitle}
                </b>

            </div>
            <div style={{ textAlign: "left" }}>
                <br /> <br />
                <b style={{ fontSize: "24px", fontFamily: 'calibri', color: "black" }}>
                    {questionText}
                </b>
                <hr />
            </div>
            <form onSubmit={answerTrueFalseHandle}>
                <div >
                    {answers && answers.map((dt) => (
                        <div className='row' key={dt.id} style={{ alignItems: 'left', marginTop: "30px", marginBottom: '10px' }}>
                            <div className='col-md-8' style={{ textAlign: "left" }}>
                                <b style={{ fontSize: "20px" }}>{dt['service']}</b>
                            </div>
                            <div className='col-md-4' >
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name={"inlineRadioOptions" + dt.id} id={dt.id + ".true"} />
                                    <label className="form-check-label" htmlFor={dt.id + ".true"}><b>True</b></label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name={"inlineRadioOptions" + dt.id} id={dt.id + ".false"} />
                                    <label className="form-check-label" htmlFor={dt.id + ".false"}><b>False</b></label>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <br /><br />
                {props.answered ? (
                    <b style={{ fontSize: "15px" }}> cevaplanmış <i>{props.realanswer}</i> </b>
                ) : (
                    <div className='d-flex justify-content-center'>
                        <button type="submit" className="save-btn">{t("saveAndContinue")}</button>
                    </div>
                )}
            </form>
            <hr />
        </div>
    );
};

export default TrueFalse;
